/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import {
    CashRegisterModelsAction,
    CashRegisterModelsActionType,
    fetchCashRegisterModelsListSuccessAction,
    fetchCashRegisterModelsListErrorAction,
    downloadCashRegisterModelsListAsExcelSuccessAction,
    downloadCashRegisterModelsListAsExcelErrorAction,
} from '../actions/cashRegisterModelsActions';
import { CashRegisterModelsListRequestParams } from '../api/cashRegisterModels/cashRegisterModelsClient.typings';
import { CashRegisterModelsState } from '../reducers/cashRegiserModelsReducer';
import { switchMap, catchError, map, exhaustMap, tap, mapTo, takeUntil } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { cashRegisterModelsClient } from '../api/cashRegisterModels/cashRegisterModelsClient';
import { AxiosError } from 'axios';
import { downloadDataAsFile, parseError } from '../../utils/utils';
import { i18n } from '../translation/i18n';

export const fetchCashRegistersEpic: Epic<CashRegisterModelsAction> = (action$, state) => {
    return action$.pipe(
        ofType(
            CashRegisterModelsActionType.OPEN_REGISTRY_CASH_REGISTER_MODELS_LIST_PAGE,
            CashRegisterModelsActionType.APPLY_PAGING,
            CashRegisterModelsActionType.APPLY_FILTERS,
            CashRegisterModelsActionType.APPLY_SORTING,
        ),
        switchMap(() => {
            const queryParams = makeCashRegistersListRequestParamsFromState(state.value.cashRegisterModelsReducer);
            return from(cashRegisterModelsClient.listCashRegistersModels(queryParams)).pipe(
                map((list) => fetchCashRegisterModelsListSuccessAction(list)),
                catchError((err: AxiosError) =>
                    of(
                        fetchCashRegisterModelsListErrorAction(
                            parseError(err, i18n.t('RegistryScreens.errors.cashRegistersModelsListReqFailed')),
                        ),
                    ),
                ),

                takeUntil(
                    action$.pipe(ofType(CashRegisterModelsActionType.EXIT_REGISTRY_CASH_REGISTER_MODELS_LIST_PAGE)),
                ),
            );
        }),
    );
};

export const cashRegistersListDownloadEpic: Epic<CashRegisterModelsAction> = (actions$, state$) => {
    return actions$.pipe(
        ofType(CashRegisterModelsActionType.DOWNLOAD_EXCEL),
        exhaustMap(() => {
            const fileName = 'cashRegistersList.xlsx';
            const queryParams = { ...state$.value.cashRegisterModelsReducer.filterParams };

            return from(cashRegisterModelsClient.downloadCashRegisterModelsAsExcel(queryParams)).pipe(
                tap((fileData) => downloadDataAsFile(fileName, fileData)),
                mapTo(downloadCashRegisterModelsListAsExcelSuccessAction()),

                catchError((err: AxiosError) =>
                    of(
                        downloadCashRegisterModelsListAsExcelErrorAction(
                            parseError(err, i18n.t('errors.failedUploadFileName', { fileName })),
                        ),
                    ),
                ),
            );
        }),
    );
};

function makeCashRegistersListRequestParamsFromState(
    state: CashRegisterModelsState,
): CashRegisterModelsListRequestParams {
    return {
        limit: state.pageParams.limit,
        offset: state.pageParams.offset,
        sort: state.sortParams.sort,
        ...state.filterParams,
    };
}
